import {CompanyTariffPackageEntity, TariffEntity} from "../../../proto/generated/api_entities_pb";
import {ITariff, ITariffPackage} from "./tariffReducerTypes";

export const mapTariffEntityToITariff = (item: TariffEntity): ITariff => {
  const companyTariffPackages: ITariffPackage[] = item.getCompanytariffpackagesList().map(pkg => {
    const tariffPackage = pkg.getTariffpackage();
    return {
      companyTariffPackageId: pkg.getCompanytariffpackageid(),
      tariffPackageId: pkg.getTariffpackageid(),
      active: pkg.getActive(),
      autoRenewal: pkg.getAutorenewal(),
      tariffEnd: pkg.getTariffend(),
      tariffPackageType: tariffPackage?.getTariffpackagetype(),
      maxPlanes: tariffPackage?.getValue(),
      isTrial: tariffPackage?.getTariffpackagetype() === 1, // Type 1 = Trial
      // Stripe fields
      stripeCustomerId: pkg.getStripecustomerid() || undefined,
      stripeSubscriptionId: pkg.getStripesubscriptionid() || undefined,
      subscriptionStatus: pkg.getSubscriptionstatus() || undefined,
      trialEndAt: pkg.getTrialendat() || undefined,
      billingCycleAnchor: pkg.getBillingcycleanchor() || undefined,
      gracePeriodUntil: pkg.getGraceperioduntil() || undefined,
      currentPeriodEnd: pkg.getCurrentperiodend() || undefined,
      subscribedUsersCount: pkg.getSubscribeduserscount?.() ?? 0,
      subscribedAircraftCount: pkg.getSubscribedaircraftcount?.() ?? 0,
      billedUsersCount: pkg.getBilleduserscount?.() ?? 0,
      billedAircraftCount: pkg.getBilledaircraftcount?.() ?? 0,
      discountPercent: (() => { const v = pkg.getDiscountpercent?.() ?? 0; return v > 0 ? v : undefined; })(),
      discountEndsAt: pkg.getDiscountendsat() || undefined,
    };
  });

  return {
    companyTariffPackages,
  };
};

